/**
 * Credential storage utility for persisting user credentials in localStorage
 * This allows automatic re-login on page refresh
 */

const CREDENTIALS_KEY = 'credentials';

export interface StoredCredentials {
  username: string;
  sessionId?: string;
  password?: string; // Only stored on localhost for easier re-authentication
}

/**
 * Save user credentials to localStorage
 * Password is optional and only saved on localhost for easier re-authentication
 */
export function saveCredentials(credentials: StoredCredentials): void {
  localStorage.setItem(CREDENTIALS_KEY, JSON.stringify(credentials));
}

/**
 * Get saved credentials from localStorage
 * Returns null if not found
 */
export function getSavedCredentials(): StoredCredentials | null {
  const credentialsStr = localStorage.getItem(CREDENTIALS_KEY);
  
  if (!credentialsStr) {
    return null;
  }

  try {
    return JSON.parse(credentialsStr);
  } catch (error) {
    console.error('Failed to parse saved credentials:', error);
    return null;
  }
}

/**
 * Clear credentials from localStorage
 * Call this on logout
 */
export function clearCredentials(): void {
  localStorage.removeItem(CREDENTIALS_KEY);
}

/**
 * Check if credentials exist in localStorage
 */
export function hasStoredCredentials(): boolean {
  return getSavedCredentials() !== null;
}
